import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';
import { VisitReportsData } from 'api/visitReports/type';

interface VisitReportsListExpandableProps {
  data: VisitReportsData;
  slug?: string;
}

const VisitReportsListExpandable: React.FC<VisitReportsListExpandableProps> = ({ data }) => {
  const { t } = useTranslation();
  const mobile = useMediaQuery(MediaBreakpoints.mobile);
  const tablet = useMediaQuery(MediaBreakpoints.tablet);
  const desktop = useMediaQuery(MediaBreakpoints.desktop);

  return (
    <div className="d-flex w-100 flex-column">
      {mobile && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('VisitReportsList.tableTitles.startDate')}</span>
          </div>
          <div className="border-bottom pb-2">{data.start_date || '-'}</div>
        </div>
      )}

      {tablet && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('VisitReportsList.tableTitles.endDate')}</span>
          </div>
          <div className="border-bottom pb-2">{data.end_date || '-'}</div>
        </div>
      )}

      {desktop && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('VisitReportsList.tableTitles.createdBy')}</span>
          </div>
          <div className="border-bottom pb-2">{data.created_by || '-'}</div>
        </div>
      )}
    </div>
  );
};

export default VisitReportsListExpandable;
